import { useEffect, useState } from "react";

import { TrackingLogic } from "@/src/logic";
import { StrapiCollectionType } from "@/src/type";

interface UseMarketingPhoneNumberProps {
  marketingSources: StrapiCollectionType.MarketingSource[];
  propertySlug: string;
}

function useMarketingPhoneNumber({ marketingSources, propertySlug }: UseMarketingPhoneNumberProps) {
  const [marketingPhoneNumber, setMarketingPhoneNumber] = useState<
    | {
        phoneNumber?: string;
        countryCode?: string;
      }
    | undefined
  >(undefined);

  useEffect(() => {
    function marketingNumberChanged() {
      const marketingPhoneNumber = TrackingLogic.getMarketingPhoneNumber(marketingSources, propertySlug);
      setMarketingPhoneNumber(marketingPhoneNumber);
    }

    marketingNumberChanged();
    window.addEventListener("storage", marketingNumberChanged, { passive: true });
    return () => {
      window.removeEventListener("storage", marketingNumberChanged);
    };
  }, [marketingSources, propertySlug]);

  return marketingPhoneNumber;
}

export default useMarketingPhoneNumber;
